<template>
  <div class="modalOverlay" v-if="isVisible">
    <div class="termsOfUseModal">
      <div class="termsOfUseModal__content">
        <div>
          <div class="termsOfUseModal__content-title">
            {{ $t('Termos de uso') }}
          </div>
          <iframe class="termsOfUseModal__content-body"  :src="terms" frameBorder="0"></iframe>
        </div>

      </div>

      <div class="termsOfUseModal__footer">
        <button @click="rejectTerms" class="reject-btn">{{ $t("Não concordo")}}</button>
        <button @click="acceptTerms" class="accept-btn">{{ $t("Li e concordo com os Termos de Uso")}}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'termsOfUseModal',
  data() {
    return {
      show: true,
      url: null
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    terms: {
      type: String,
      default: ''
    },
  },
  methods: {
    async acceptTerms() {
      this.$emit('accept');
      this.closeModal();
    },

    async rejectTerms() {
      this.$emit('reject');
      this.closeModal();
    },

    closeModal() {
      this.show = false;
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss">
  .modalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
  }

  .termsOfUseModal {
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 8px;
    background: #FFF;
    display: flex;
    padding: 16px 24px;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    overflow-y: hidden;
    z-index: 100;

    position: fixed;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%)
  }

  .termsOfUseModal__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    gap: 32px;
  }

  .termsOfUseModal__content > div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    gap: 32px;
  }

  .termsOfUseModal__content-title {
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 125.303%;
    color: #3A424E
  }

  .termsOfUseModal__content-body {
    overflow-y: auto;
    overflow-x: auto;
    max-width: 1100px;
    min-height: 400px;
    width: 800px;
  }

  .termsOfUseModal__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    button:nth-child(1) {
      color: #3A424E80;
      display: flex;
      padding: 6px 16px;
      font-weight: 600;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      border: none;
      background-color: transparent;
    }

    button:nth-child(2) {
      color: #1b59f8;
      display: flex;
      padding: 6px 16px;
      font-weight: 600;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      border: none;
      background-color: transparent;
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/views/modals/termsOfUse.vue